import React from 'react';
import { Tabs, Tab, Box } from '@mui/material';
import {
  AccountTree as FlowIcon,
  Timeline as EdgeIcon,
  DataObject as StateIcon,
  Settings as SettingsIcon,
  Cloud as MCPIcon,
} from '@mui/icons-material';

function FlowBuilderTabs({ selectedTab, onTabChange }) {
  return (
    <Tabs
      value={selectedTab}
      onChange={(e, newValue) => onTabChange(newValue)}
      sx={{
        borderBottom: 1, borderColor: 'divider', px: 2, flex: 1,
      }}
    >
      <Tab
        icon={<FlowIcon />}
        label="Design"
        iconPosition="start"
      />
      <Tab
        icon={<EdgeIcon />}
        label="Edges"
        iconPosition="start"
      />
      <Tab
        icon={<StateIcon />}
        label="State"
        iconPosition="start"
      />
      <Tab
        icon={<SettingsIcon />}
        label="Settings"
        iconPosition="start"
      />
      <Tab
        icon={<MCPIcon />}
        label="MCP"
        iconPosition="start"
      />
    </Tabs>
  );
}

export default FlowBuilderTabs;
